module.exports = __webpack_public_path__ + "img/div1.1f513a80.png";